import React, { memo, useCallback, useContext, useState } from 'react';
import { Box, Flex, Stack } from '@chakra-ui/layout';
import { Button, RadioInput, Unform, Label, AddObservation } from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import TPA from 'models/Forms/TPA';
import { ThirdPartyAssessmentCtx } from 'pages';

import CommentedAnswer, { yo } from 'models/CommentedAnswer';
import { checkPermission } from 'utils/authentication';

const Item: React.FC<BodyProps> = ({ functionCallback, index, submit, completed }) => {
  const ctx = useContext(ThirdPartyAssessmentCtx);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    setLoading(true);
    if (submit) {
      const resp = await submit({}, '4 - Teste de Risco de Contrato');
      if (resp) {
        functionCallback(index + 1);
      }
    } else {
      functionCallback(index + 1);
    }
    setLoading(false);
  }, [submit, functionCallback, index]);

  const handleField = useCallback(
    (
      k1: keyof TPA['jsonContractAvaliation'],
      k2: keyof CommentedAnswer,
      e: React.ChangeEvent<HTMLInputElement> | yo,
    ) => {
      ctx.handlePayload(dt => {
        const data = {
          ...dt,
        };
        if (k2 === 'comments' && typeof e !== 'string')
          data.jsonContractAvaliation[k1][k2] = e.target.value;
        else if (typeof e === 'string') data.jsonContractAvaliation[k1][k2] = e;
        return data;
      });
    },
    [ctx.handlePayload],
  );
  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform
        initialData={ctx.data}
        onSubmit={handleSubmit}
        // validationSchema={ContractRiskValidationSchema}
      >
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Box mb="24px">
              <Label
                flex={1}
                tip={
                  <>
                    <p>
                      Para o objeto contratual ser executado, é obrigatório ocorrer o tratamento de
                      dados pessoais?
                    </p>
                    <p>
                      {`Caso contrário (ex.: atividade é 'aquisição de papel para impressora', ainda que
                  envolva o dado do representante da parte contrária), marcar "não".`}
                    </p>
                  </>
                }
              >
                Relevância do tratamento de dados pessoais
              </Label>
              <p>A(s) atividade(s) core do contrato envolvem o tratamento de dados pessoais?</p>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="relevance"
                  label={
                    ctx.data.jsonContractAvaliation?.relevance.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.relevance.answer}
                  onChange={handleField.bind(null, 'relevance', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.relevance.comments}
                  onChangeEvent={handleField.bind(null, 'relevance', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="A partir dos documentos relativos à contratação, é possível delimitar os tipos de dados pessoais que serão tratados (leia-se, coletado, recebido, processado ou compartilhado etc.)?"
              >
                Minimização de dados
              </Label>
              <p>É possível delimitar quais dados podem ser tratados em decorrência do contrato?</p>
              <Box mt="8px">
                <RadioInput
                  name="dataMinimization"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.dataMinimization.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.dataMinimization.answer}
                  onChange={handleField.bind(null, 'dataMinimization', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.dataMinimization.comments}
                  onChangeEvent={handleField.bind(null, 'dataMinimization', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Aqui importa saber se a atividade que está relacionada ao objeto do contrato está dentro da expectativa dos titulares de dados."
              >
                Transparência
              </Label>
              <p>
                É possível assegurar que os propósitos da atividade que é objeto do contrato são
                claros e informados aos titulares?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="transparency"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.transparency.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.transparency.answer}
                  onChange={handleField.bind(null, 'transparency', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.transparency.comments}
                  onChangeEvent={handleField.bind(null, 'transparency', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Dados sensíveis são aqueles que revelem origem racial ou étnica, convicção religiosa,
            opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico
            ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico,
            quando vinculado a uma pessoa natural"
              >
                Dados sensíveis
              </Label>
              <p>Contrato envolve ou pode envolver tratamento de dados sensíveis?</p>
              <Box mt="8px">
                <RadioInput
                  name="sensitiveData"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.sensitiveData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.sensitiveData.answer}
                  onChange={handleField.bind(null, 'sensitiveData', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.sensitiveData.comments}
                  onChangeEvent={handleField.bind(null, 'sensitiveData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Exemplos: dados de extratos bancários, renda, transações financeiras, números de contas, cartões de crédito etc."
              >
                Dados financeiros
              </Label>
              <p>
                Contrato envolve ou pode envolver o tratamento de dados relativos à vida financeira
                dos indivíduos?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="financialData"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.financialData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.financialData.answer}
                  onChange={handleField.bind(null, 'financialData', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.financialData.comments}
                  onChangeEvent={handleField.bind(null, 'financialData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Considera o monitoramento do comportamento online ou offline, incluída a supervisão constante de empregados (por exemplo)"
              >
                Monitoramento de titulares
              </Label>
              <p>
                Contrato envolve ou pode envolver monitoramento constante de hábitos,
                comportamentos, consumo ou rotina dos indivíduos?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="monitoringHolders"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.monitoringHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.monitoringHolders.answer}
                  onChange={handleField.bind(null, 'monitoringHolders', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.monitoringHolders.comments}
                  onChangeEvent={handleField.bind(null, 'monitoringHolders', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Tecnologias inovadoras para processamento de dados, via de regra, ainda não tiveram seus limites (inclusive éticos) examinados pela sociedade, muito menos pelas autoridades, elevando-se, assim, o grau de incerteza jurídica."
              >
                Novas tecnologias
              </Label>
              <p>
                Contrato envolve ou pode envolver o uso de tecnologias disruptivas e de uso ainda
                não comum?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="newTechnologies"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.newTechnologies.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.newTechnologies.answer}
                  onChange={handleField.bind(null, 'newTechnologies', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.newTechnologies.comments}
                  onChangeEvent={handleField.bind(null, 'newTechnologies', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Tratamento de dados de crianças ou adolescentes apresentam risco adicional, dada a maior vulnerabilidade desses titulares"
              >
                Dados de menores de idade
              </Label>
              <p>
                Contrato tem foco ou envolve considerável tratamento de dados pessoais de crianças
                e/ou adolescentes?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="minorData"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.minorData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.minorData.answer}
                  onChange={handleField.bind(null, 'minorData', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.minorData.comments}
                  onChangeEvent={handleField.bind(null, 'minorData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Na doutrina de proteção de dados, dados de pessoas consideradas em estado de vulnerabilidade merecem cuidados adicionais."
              >
                Dados de vulneráveis
              </Label>
              <p>
                Contrato tem foco ou envolve considerável tratamento de dados pessoais de idosos
                e/ou pessoas com deficiência?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="vulnerableData"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.vulnerableData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.vulnerableData.answer}
                  onChange={handleField.bind(null, 'vulnerableData', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.vulnerableData.comments}
                  onChangeEvent={handleField.bind(null, 'vulnerableData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Dados relativos a condenações/antecedentes criminais carregam em si um alto potencial discriminatório."
              >
                Dados/registros criminais
              </Label>
              <p>
                Contrato envolve ou pode envolver o tratamento de dados pessoais relacionados a
                condenações/antecedentes criminais?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="criminalData"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.criminalData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.criminalData.answer}
                  onChange={handleField.bind(null, 'criminalData', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.criminalData.comments}
                  onChangeEvent={handleField.bind(null, 'criminalData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label flex={1} tip="Seja perfil de consumo, hábito, preferências, interesses etc.">
                Profiling
              </Label>
              <p>
                Contrato envolve ou pode envolver atividade de criação de perfis de pessoas físicas?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="profiling"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.profiling.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.profiling.answer}
                  onChange={handleField.bind(null, 'profiling', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.profiling.comments}
                  onChangeEvent={handleField.bind(null, 'profiling', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Exemplos de decisões automatizadas comumente verificados: classificações, rankeamento, perfilamento, concessão ou negação de crédito etc"
              >
                Decisões automatizadas
              </Label>
              <p>
                Contrato envolve ou pode envolver decisões automatizadas (sem participação humana)
                baseadas em dados pessoais?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="automatedDecisions"
                  // {...cProps}
                  label={
                    ctx.data.jsonContractAvaliation?.automatedDecisions.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.automatedDecisions.answer}
                  onChange={handleField.bind(null, 'automatedDecisions', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.automatedDecisions.comments}
                  onChangeEvent={handleField.bind(null, 'automatedDecisions', 'comments')}
                />
              </Box>
            </Box>

            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Box mb="24px">
              <Label
                flex={1}
                tip={
                  <>
                    <p>
                      Para o objeto contratual ser executado, é obrigatório ocorrer o tratamento de
                      dados pessoais?
                    </p>
                    <p>
                      {`Caso contrário (ex.: atividade é 'aquisição de papel para impressora', ainda que
                  envolva o dado do representante da parte contrária), marcar "não".`}
                    </p>
                  </>
                }
              >
                Relevância do tratamento de dados pessoais
              </Label>
              <p>A(s) atividade(s) core do contrato envolvem o tratamento de dados pessoais?</p>
              <Box mt="8px">
                <RadioInput
                  name="relevance"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.relevance.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.relevance.answer}
                  onChange={handleField.bind(null, 'relevance', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.relevance.comments}
                  onChangeEvent={handleField.bind(null, 'relevance', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="A partir dos documentos relativos à contratação, é possível delimitar os tipos de dados pessoais que serão tratados (leia-se, coletado, recebido, processado ou compartilhado etc.)?"
              >
                Minimização de dados
              </Label>
              <p>É possível delimitar quais dados podem ser tratados em decorrência do contrato?</p>
              <Box mt="8px">
                <RadioInput
                  name="dataMinimization"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.dataMinimization.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.dataMinimization.answer}
                  onChange={handleField.bind(null, 'dataMinimization', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.dataMinimization.comments}
                  onChangeEvent={handleField.bind(null, 'dataMinimization', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Aqui importa saber se a atividade que está relacionada ao objeto do contrato está dentro da expectativa dos titulares de dados."
              >
                Transparência
              </Label>
              <p>
                É possível assegurar que os propósitos da atividade que é objeto do contrato são
                claros e informados aos titulares?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="transparency"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.transparency.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.transparency.answer}
                  onChange={handleField.bind(null, 'transparency', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.transparency.comments}
                  onChangeEvent={handleField.bind(null, 'transparency', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Dados sensíveis são aqueles que revelem origem racial ou étnica, convicção religiosa,
            opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico
            ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico,
            quando vinculado a uma pessoa natural"
              >
                Dados sensíveis
              </Label>
              <p>Contrato envolve ou pode envolver tratamento de dados sensíveis?</p>
              <Box mt="8px">
                <RadioInput
                  name="sensitiveData"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.sensitiveData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.sensitiveData.answer}
                  onChange={handleField.bind(null, 'sensitiveData', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.sensitiveData.comments}
                  onChangeEvent={handleField.bind(null, 'sensitiveData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Exemplos: dados de extratos bancários, renda, transações financeiras, números de contas, cartões de crédito etc."
              >
                Dados financeiros
              </Label>
              <p>
                Contrato envolve ou pode envolver o tratamento de dados relativos à vida financeira
                dos indivíduos?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="financialData"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.financialData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.financialData.answer}
                  onChange={handleField.bind(null, 'financialData', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.financialData.comments}
                  onChangeEvent={handleField.bind(null, 'financialData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Considera o monitoramento do comportamento online ou offline, incluída a supervisão constante de empregados (por exemplo)"
              >
                Monitoramento de titulares
              </Label>
              <p>
                Contrato envolve ou pode envolver monitoramento constante de hábitos,
                comportamentos, consumo ou rotina dos indivíduos?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="monitoringHolders"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.monitoringHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.monitoringHolders.answer}
                  onChange={handleField.bind(null, 'monitoringHolders', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.monitoringHolders.comments}
                  onChangeEvent={handleField.bind(null, 'monitoringHolders', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Tecnologias inovadoras para processamento de dados, via de regra, ainda não tiveram seus limites (inclusive éticos) examinados pela sociedade, muito menos pelas autoridades, elevando-se, assim, o grau de incerteza jurídica."
              >
                Novas tecnologias
              </Label>
              <p>
                Contrato envolve ou pode envolver o uso de tecnologias disruptivas e de uso ainda
                não comum?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="newTechnologies"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.newTechnologies.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.newTechnologies.answer}
                  onChange={handleField.bind(null, 'newTechnologies', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.newTechnologies.comments}
                  onChangeEvent={handleField.bind(null, 'newTechnologies', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Tratamento de dados de crianças ou adolescentes apresentam risco adicional, dada a maior vulnerabilidade desses titulares"
              >
                Dados de menores de idade
              </Label>
              <p>
                Contrato tem foco ou envolve considerável tratamento de dados pessoais de crianças
                e/ou adolescentes?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="minorData"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.minorData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.minorData.answer}
                  onChange={handleField.bind(null, 'minorData', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.minorData.comments}
                  onChangeEvent={handleField.bind(null, 'minorData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Na doutrina de proteção de dados, dados de pessoas consideradas em estado de vulnerabilidade merecem cuidados adicionais."
              >
                Dados de vulneráveis
              </Label>
              <p>
                Contrato tem foco ou envolve considerável tratamento de dados pessoais de idosos
                e/ou pessoas com deficiência?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="vulnerableData"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.vulnerableData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.vulnerableData.answer}
                  onChange={handleField.bind(null, 'vulnerableData', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.vulnerableData.comments}
                  onChangeEvent={handleField.bind(null, 'vulnerableData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Dados relativos a condenações/antecedentes criminais carregam em si um alto potencial discriminatório."
              >
                Dados/registros criminais
              </Label>
              <p>
                Contrato envolve ou pode envolver o tratamento de dados pessoais relacionados a
                condenações/antecedentes criminais?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="criminalData"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.criminalData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.criminalData.answer}
                  onChange={handleField.bind(null, 'criminalData', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.criminalData.comments}
                  onChangeEvent={handleField.bind(null, 'criminalData', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label flex={1} tip="Seja perfil de consumo, hábito, preferências, interesses etc.">
                Profiling
              </Label>
              <p>
                Contrato envolve ou pode envolver atividade de criação de perfis de pessoas físicas?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="profiling"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.profiling.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.profiling.answer}
                  onChange={handleField.bind(null, 'profiling', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.profiling.comments}
                  onChangeEvent={handleField.bind(null, 'profiling', 'comments')}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label
                flex={1}
                tip="Exemplos de decisões automatizadas comumente verificados: classificações, rankeamento, perfilamento, concessão ou negação de crédito etc"
              >
                Decisões automatizadas
              </Label>
              <p>
                Contrato envolve ou pode envolver decisões automatizadas (sem participação humana)
                baseadas em dados pessoais?
              </p>
              <Box mt="8px">
                <RadioInput
                  name="automatedDecisions"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonContractAvaliation?.automatedDecisions.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonContractAvaliation?.automatedDecisions.answer}
                  onChange={handleField.bind(null, 'automatedDecisions', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonContractAvaliation.automatedDecisions.comments}
                  onChangeEvent={handleField.bind(null, 'automatedDecisions', 'comments')}
                />
              </Box>
            </Box>

            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const ContractRiskTest = memo(Item);
